import React from 'react';

const MobileLogo = () => {
    return (
        <img src={require('../../../assets/mobile_logotype.png')} width={28} height={22} draggable={false} style={{margin:0}}/>
    );
};

export default MobileLogo;